import { render, staticRenderFns } from "./FormRulesPictograms.vue?vue&type=template&id=ae60448a&scoped=true"
import script from "./FormRulesPictograms.vue?vue&type=script&lang=js"
export * from "./FormRulesPictograms.vue?vue&type=script&lang=js"
import style0 from "./FormRulesPictograms.vue?vue&type=style&index=0&id=ae60448a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae60448a",
  null
  
)

export default component.exports